const bicCacheName = 'bicCache';

export const cached = (fn) => {
  const cachedFn = async (url, headers) => {
    const bicCache = await caches.open(bicCacheName);
    let response = await bicCache.match(url);
    if (!response) {
      response = await fn(url, headers);
      if (response.ok) {
        await bicCache.put(url, response);
        return bicCache.match(url);
      }
    }
    return response;
  }
  return cachedFn;
}

export const clearCache = () => {
  return function(cacheName) {
    caches.delete(cacheName)
  }(bicCacheName);
}